import React from 'react';
import proptypes from 'prop-types';
const { number } = proptypes;
import { ProjectTilePlaceholder } from './project-tile/ProjectTilePlaceholder';

export const LoadingProjectSummary = ({ numberPlaceholders }) => {
  const placeholders = Array.from(Array(numberPlaceholders));

  return (
    <div
      data-testid="projects-placeholder"
      className="sui-col-span-4 sui-grid sui-gap-3 sui-grid-cols-1 md:sui-grid-cols-2
      lg:sui-grid-cols-3"
    >
      {
        placeholders.map((__, index) => (
          <ProjectTilePlaceholder key={`placeholder-${index}`} />
        ))
      }
    </div>
  );
};

LoadingProjectSummary.propTypes = {
  numberPlaceholders: number.isRequired
};
